import Nav_Links_Item from "./Nav_Links_Item";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import React from "react";

const Nav_Links = (props) => {
    return(
        <div className="nav_links_div">
            <Link className="nav_link" to="/"><Nav_Links_Item classTitle="fa-house-user" text="Home" /></Link>
            <Link className="nav_link" to="/users"><Nav_Links_Item classTitle="fa-user-group" text="Users" /></Link>
            <Link className="nav_link" to={`/messages/${props.user.id}`}><Nav_Links_Item classTitle="fa-envelope-open-text" text="Messages" /></Link>
            <Link className="nav_link" to="/profile"><Nav_Links_Item classTitle="fa-address-card" text="Profile" /></Link>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user
    }
}
export default connect(mapStateToProps)(Nav_Links);